module.exports = __webpack_public_path__ + "static/img/cc.d91045b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/cc.png
// module id = Qlza
// module chunks = 0